<div class="errorHandler">
    <span [translate]="'COMMON.ERROR_TITLE_TEXT'" 
    [translateParams]="{ supportEmail: supportEmailId }"></span>
</div>